module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/j5ZHSIOlWUwOMSplQgr68-416a2d39125a3088e147565f9ae5091c.jpg";